<div #modalAnular class="modal fade" id="dialogAnular" tabindex="-1" role="dialog" aria-labelledby="Anular" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Anulação de Empenho Orçamentário</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="accordion" id="accordion">
          <div class="card">
            <div class="card-header">
              <button (click)="buscarAnulacoes()" class="btn btn-sm" data-toggle="collapse"
                data-target="#collapseHistorico" aria-expanded="false" aria-controls="collapseHistorico">
                <em class="fa fa-history" style="margin: 0 10px 0 -10px"></em>Histórico de anulações
              </button>
            </div>
            <div class="collapse" id="collapseHistorico" aria-labelledby="bloco-historico" data-parent="#accordion">
              <div class="card-body p-0">
                <table class="table table-eddy">
                  <thead class="thead-light">
                    <tr>
                      <th scope="col" class="text-center">Data</th>
                      <th scope="col">Usuário</th>
                      <th scope="col" class="text-right">Valor</th>
                      <th scope="col">Histórico</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of listAnulacoes">
                      <td class="text-center">{{item.data_empenho | date:'dd/MM/yyyy':'GMT'}}</td>
                      <td>{{item.usuario_cadastro ? item.usuario_cadastro.nome : item.usuario_cadastro}}</td>
                      <td class="text-right">{{item.valor_empenho | number:'1.2-2'}}</td>
                      <td>{{item.historico}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <button class="btn btn-sm" data-toggle="collapse" data-target="#collapseAnulacao" aria-expanded="false"
                aria-controls="collapseAnulacao">
                <em class="fa fa-undo" style="margin: 0 10px 0 -10px"></em>Dados da anulação
              </button>
            </div>
            <div class="collapse show" id="collapseAnulacao" aria-labelledby="bloco-anulacao" data-parent="#accordion">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <label for="data_empenho_anulacao">Data anulação<span class="text-danger">*</span></label>
                    <p-calendar [(ngModel)]="data" id="data_empenho_anulacao" inputStyleClass="form-control"
                      dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                      [showButtonBar]="true" [style]="{ width: '100%' }">
                    </p-calendar>
                  </div>
                  <div class="col-md-4">
                    <label for="valor_empenho_anulacao">Valor anulação<span class="text-danger">*</span></label>
                    <input unmask="typed" [imask]="imaskConfig" type="text" class="form-control text-right"
                      id="valor_empenho_anulacao" [(ngModel)]="valor" placeholder="0,00"
                      style="font-weight: bold; color: #1e88e5">
                  </div>

                  <div *ngIf="compraId > 0 && compra" class="col-4 mt-4">
                    <img alt="" src="assets/img/cost.png" width="26" height="26" />
                    <span class="font-weight-bold">TOTAL OF.: {{total | number:'1.2-2'}}</span>
                  </div>

                </div>
                <hr class="mt-2 mb-2" />
                <div class="row">
                  <div class="col-md-12">
                    <label for="historico_anulacao">Justificativa<span class="text-danger">*</span></label>
                    <textarea [(ngModel)]="historico" class="form-control" id="historico_anulacao" rows="4"></textarea>
                  </div>
                </div>
                <div *ngIf="compraId > 0 && compra" class="row mt-2">
                  <div class="col-md-12">
                    <div style="height: 210px; overflow-y: visible;" class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th scope="col" class="text-right">Quantidade</th>
                            <th scope="col" class="text-center">Descrição</th>
                            <th scope="col" class="text-right">Vl.Unitário</th>
                            <th scope="col" class="text-right">Vl.Total</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of compra.itens; let idx = index">
                            <td style="text-align: right; width: 120px;">
                              <p-inplace #inplaceQuant>
                                <span pInplaceDisplay>
                                  {{item.quantidade | number:'1.3-3'}}
                                </span>
                                <span pInplaceContent>
                                  <input type="text" [(ngModel)]="item.quantidade" [ngModelOptions]="{standalone: true}"
                                    unmask="true" [imask]="imaskConfig" (blur)="salvarItem(item)"
                                    class="form-control form-control-sm text-right">
                                </span>
                              </p-inplace>
                            </td>
                            <td>{{item.produto_unidade.produto.nome}}</td>
                            <td style="text-align: right;">{{item.valor_unitario | number:'1.2-2'}}</td>
                            <td style="text-align: right; width: 150px;">
                              <p-inplace #inplaceValor>
                                <span pInplaceDisplay>
                                  {{+item.valor_unitario * +item.quantidade | number:'1.2-2'}}
                                </span>
                                <span pInplaceContent>
                                  <input type="text" [(ngModel)]="item.valor_total"
                                    [ngModelOptions]="{standalone: true}" unmask="true" [imask]="imaskConfig"
                                    (blur)="salvarItem(item)" class="form-control form-control-sm text-right">
                                </span>
                              </p-inplace>
                            </td>
                            <td class="text-right">
                              <button *ngIf="!item.editavel" (click)="confirmarRemocao(item, idx)"
                              class="btn btn-sm btn-outline-primary mr-2">
                              <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
                            </button>
                            </td>
                          </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <br>
              </div>

              <div class="card-footer p-3">
                <button (click)="anular()" type="submit"
                  class="btn btn-danger btn-sm float-right ml-2">Confirmar</button>
                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog [appendTo]="modalAnular" [style]="{width: '40vw'}"></p-confirmDialog>